import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';

@Component({
    selector: 'dms-servibox-icon',
    templateUrl: './servibox-icon.component.html',
    styleUrls: ['./servibox-icon.component.scss']
})
export class ServiboxIconComponent implements OnInit {
    _key: string = 'vin'
    _value: string = '';
    @Input() styleClass: string;
    @Input() set key(val: string){
        this._key = val;
    }
    @Input() set value(val: string){
        this._value = val;
    }

    constructor(private authService: AuthService) { }

    ngOnInit() {
    }

    openUrl() {
        const url = `${this.authService.getSeviboxURL()}/panier/vehicule.do?${this._key}=${this._value}`;
        window.open(url, '_blank');
    }

}
